import { Effects, loop } from 'redux-loop';
import _ from 'lodash';

import {
  GET_COLLECTION,
  GET_COLLECTION_SUCCESS,
  SET_COLLECTION,
  DELETE_COLLECTION,
  FETCH_COLLECTION_FEED,
  fetchCollectionFeed,
  FETCH_COLLECTION_FEED_SUCCESS,
  FETCH_COLLECTION_ARCHIVE,
  FETCH_COLLECTION_ARCHIVE_SUCCESS,
  CLOSE_LOADING,
  TOUCH_DOWNLOAD_MODAL,

} from './actions';
import {reducer as feedReducer} from 'modules/feed';

import { getCollection, setCollection, fetchCollectionArchive, createdCollection, deleteCollection } from './tasks';

const initialState = {
  globalIds:[],
  clippingFeed: {
    isLoading: false,
    data: [],
  },
  archive: {
    isLoading: false,
    data: []
  },
  loadingList: [],

  isOpen: false,
}



export default (state=initialState, action) => {

  if (action.type === TOUCH_DOWNLOAD_MODAL) {
    return loop({
      ... state,
      isOpen: !state.isOpen
    },
      Effects.none()
    )
  }

  if(action.type === GET_COLLECTION) {
    return loop(
      state,
      Effects.call(getCollection)
      // Effects.promise(getCollection, action.data)
    )
  }

  if(action.type === GET_COLLECTION_SUCCESS) {
    // const globalIds = _.map(_.get(action, 'data.data.clippings.data'), 'globalId');
    // const ids = _.map(_.get(action, 'data.data.clippings.data'), 'id');
    // return loop({
    //   ...state,
    //   ...action.data,
    //   globalIds: globalIds,
    //   ids: ids,
    //   loadingList: _.reject(state.loadingList, (item) => {return _.includes(globalIds, item)})
    // },
    //   Effects.none()
    // )
    return loop({
      ...state,
      globalIds: action.data
    },
      Effects.none()
    )
  }

  if(action.type === FETCH_COLLECTION_FEED) {
    const [ feedModel, feedEffect ] = feedReducer(state.feed, action.action);
    return loop({
      ...state,
      clippingFeed: feedModel
    }
    ,
      Effects.batch([
        Effects.lift(feedEffect, fetchCollectionFeed)
      ])
    )
  }

  if(action.type === FETCH_COLLECTION_FEED_SUCCESS) {
    const list = _.sortBy(action.data.data, (d) => {
      return _.indexOf(state.globalIds, d.globalId)
    })

    return loop({
      ...state,
      clippingFeed: {
        ...state.clippingFeed,
        isLoading: false,
        data: list,
      }
    }
    ,
      Effects.none()
    )
  }

  if(action.type === FETCH_COLLECTION_ARCHIVE) {
    return loop({
      ...state,
      archive: {
        ...state.archive,
        isLoading: true,
      }
    }
    ,
      Effects.promise(fetchCollectionFeed, action.data)
    )
  }

  if(action.type === FETCH_COLLECTION_ARCHIVE_SUCCESS) {
    return loop({
      ...state,
      archive: {
        ...state.archive,
        isLoading: false,
        data: action.data,
      }
    }
    ,
      Effects.none()
    )
  }

  if(action.type === SET_COLLECTION) {
    return loop(
      state
    ,
      Effects.call(setCollection, action.data)
    )
  }

  if(action.type === DELETE_COLLECTION) {
    const data = _.get(state, 'data.clippings.data');
    let globalData = [];
    _.map(action.data.globalId, (globalId) => {
      globalData = [...globalData, _.find(data, (o) => { return o.globalId == globalId; })]
    })
    globalData = _.map(globalData, 'id');
    return loop(
      state
    ,
      Effects.promise(deleteCollection, {ids: globalData, userId: action.data.userId})
    )
  }

  if (action.type === CLOSE_LOADING) {
    return loop({
      ...state,
      loadingList: _.reject(state.loadingList, (item) => {return _.includes(action.data, item)})
    },
      Effects.none()
    )
  }

  return loop(state, Effects.none());
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/collection/reducer.js
 **/